"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.request = void 0;
/**
 * A request handler function for invoking the endpoint via the given client.
 *
 * This function is bound to the types declared in {@link PatchUserProfile},
 * meaning the request and response types can be validated by the build.
 */
const request = async (client, configuration) => {
    const { credentials, hostname, signal, path, payload } = configuration;
    return client({
        credentials,
        hostname,
        signal,
        method: 'PATCH',
        path: `/users/${path.userId}/profile`,
        payload,
    });
};
exports.request = request;
